<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <MmmmRequestForm :propsMmmmNo="mmmmNo" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MmmmRequestForm from '@/components/organisms/terminal/form/MmmmRequestForm'

export default {
  name: 'MmmmRequestPage',

  components: {
    MmmmRequestForm,
  },

  data() {
    return {
      mmmmNo: '',
    }
  },

  created() {
    const query = this.$route.query
    if (query.mmmmNo) {
      this.mmmmNo = query.mmmmNo
    }
  },
}
</script>
